import React, { useState } from "react";
import Marquee from "react-fast-marquee";
import Deadline from "./Deadline";
import Deadlinetext from "./DeadlineData";
import "./Dealine_ScrollBar.css";
var dlscrollfun;

function Dealine_ScrollBar() {
  const [dlscroll, setdlscroll] = useState(true);
  dlscrollfun = (bool) => {
    setdlscroll(bool);
  };

  return (
    <>
      <div
        onClick={(event) => {
          event.stopPropagation();
        }}
        id="deadline"
        className="fixed-top"
      >
        <div className="deadlineContainer">
          <Marquee
            play={dlscroll}
            pauseOnClick={true}
            pauseOnHover={true}
            gradient={false}
            speed={"30"}
          >
            <div className="deadlineInner">
              <div className="deadlineItem" id="deadlineItem">
                {Deadlinetext.map((deadline, i) => {
                  return <Deadline deadline={deadline} key={i} />;
                })}
              </div>
            </div>
          </Marquee>
        </div>
      </div>
    </>
  );
}

export { dlscrollfun };
export default Dealine_ScrollBar;
